import Vue from "vue";
import NewsArticle from "@/stories/Components/NewsArticle/NewsArticle";

Vue.component("NewsArticle", NewsArticle);
